import { useCallback } from 'react'
import { PlatformLevel } from '@pushly/aqe/lib/types/platform-level'
import { useHistory } from 'react-router-dom'
import type { NotificationListRouteState } from '../../../../notification-list/notification-list'

export type BackToParentViewCallbackProps = {
    level: PlatformLevel
    domainId?: number | string
    orgId?: number | string
    resolveParentRoute?(isDraft: boolean): string
}

export const useNotificationBuilderViewBackToParentViewCallback = (props: BackToParentViewCallbackProps) => {
    const historyApi = useHistory()

    const { level, domainId, orgId, resolveParentRoute } = props

    if (level === 'org' && !orgId) {
        throw new Error('useNotificationBuilderViewBackToParentViewCallback: orgId is required for org level')
    }
    if (level === 'domain' && !domainId) {
        throw new Error('useNotificationBuilderViewBackToParentViewCallback: domainId is required for domain level')
    }

    return useCallback(
        (isDraft: boolean = false) => {
            let parentRoute: string
            if (resolveParentRoute) {
                parentRoute = resolveParentRoute(isDraft)
            } else if (level === 'org') {
                parentRoute = `/organizations/${orgId}/notifications`
            } else {
                parentRoute = isDraft
                    ? `/domains/${domainId}/notifications/drafts`
                    : `/domains/${domainId}/notifications`
            }

            // The org Drafts tab opens on multi-domain drafts only, which hides a draft just saved to
            // one domain; after a save it opens on every scope instead.
            const state: NotificationListRouteState | undefined =
                level === 'org' && isDraft ? { draftListFilters: { showAllNotifications: true } } : undefined

            historyApi.push(parentRoute, state)
        },
        [level, domainId, orgId, resolveParentRoute],
    )
}
